// Role color mapping
export const getRoleColor = (role) => {
  const colors = {
    'super_user': '#8B5CF6',      // Purple
    'agency_manager': '#EF4444',   // Red
    'npo_manager': '#3B82F6',      // Blue
    'team_manager': '#10B981',     // Green
    'mediator': '#F59E0B',         // Orange
    'beneficiary': '#6B7280'       // Gray
  };
  return colors[role] || '#6B7280';
};

// Get role display name
export const getRoleDisplayName = (role) => {
  const roleNames = {
    'super_user': 'Super User',
    'agency_manager': 'Agency Manager',
    'npo_manager': 'NPO Manager',
    'team_manager': 'Team Manager',
    'mediator': 'Mediator',
    'beneficiary': 'Beneficiary'
  };
  return roleNames[role] || role;
};

// Format relative time
export const formatRelativeTime = (isoDate) => {
  if (!isoDate) return '';
  
  const now = new Date();
  const messageDate = new Date(isoDate);
  const diffInSeconds = Math.floor((now - messageDate) / 1000);
  
  if (diffInSeconds < 60) {
    return 'Just now';
  } else if (diffInSeconds < 3600) {
    const minutes = Math.floor(diffInSeconds / 60);
    return `${minutes} minute${minutes > 1 ? 's' : ''} ago`;
  } else if (diffInSeconds < 86400) {
    const hours = Math.floor(diffInSeconds / 3600);
    return `${hours} hour${hours > 1 ? 's' : ''} ago`;
  } else if (diffInSeconds < 604800) {
    const days = Math.floor(diffInSeconds / 86400);
    return `${days} day${days > 1 ? 's' : ''} ago`;
  } else {
    // For older messages, show the actual date
    return messageDate.toLocaleDateString();
  }
};

// Format message timestamp for display
export const formatMessageTime = (isoDate) => {
  if (!isoDate) return '';
  
  const date = new Date(isoDate);
  const now = new Date();
  const isToday = date.toDateString() === now.toDateString();
  
  if (isToday) {
    return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  } else {
    return date.toLocaleDateString([], { 
      month: 'short', 
      day: 'numeric',
      hour: '2-digit', 
      minute: '2-digit' 
    });
  }
};

// Parse system message icons
export const getSystemMessageIcon = (messageType, message) => {
  if (messageType === 'event_creation') return '📅';
  if (messageType === 'event_update') return '✏️';
  if (messageType === 'status_change') return '🎯';
  if (messageType === 'mediator_response') {
    if (message.includes('accepted') || message.includes('confirmed')) return '✅';
    if (message.includes('declined') || message.includes('rejected')) return '❌';
  }
  if (messageType === 'whatsapp_response') return '✅';
  return '📋';
};

// Check if user can delete messages
export const canDeleteMessage = (userRole) => {
  const privilegedRoles = ['super_user', 'agency_manager', 'npo_manager'];
  return privilegedRoles.includes(userRole);
};

// Check if user can send messages (not for revoked events)
export const canSendMessage = (eventStatus) => {
  return eventStatus !== 'revoke';
};

// Sanitize message content to prevent XSS
export const sanitizeMessage = (message) => {
  if (!message) return '';
  
  // Basic HTML escaping
  const div = document.createElement('div');
  div.textContent = message;
  return div.innerHTML;
};

// Parse message content for emojis and line breaks
export const parseMessageContent = (message) => {
  if (!message) return '';
  
  // Convert line breaks to <br> tags
  const withBreaks = message.replace(/\n/g, '<br>');
  
  return withBreaks;
};

// Group messages by date
export const groupMessagesByDate = (messages) => {
  const groups = {};
  
  messages.forEach(message => {
    const date = new Date(message.created_at);
    const dateKey = date.toDateString();
    
    if (!groups[dateKey]) {
      groups[dateKey] = [];
    }
    groups[dateKey].push(message);
  });
  
  return groups;
};

// Get date header text
export const getDateHeaderText = (dateString) => {
  const date = new Date(dateString);
  const today = new Date();
  const yesterday = new Date(today);
  yesterday.setDate(yesterday.getDate() - 1);
  
  if (date.toDateString() === today.toDateString()) {
    return 'Today';
  } else if (date.toDateString() === yesterday.toDateString()) {
    return 'Yesterday';
  } else {
    return date.toLocaleDateString([], { 
      weekday: 'long', 
      year: 'numeric', 
      month: 'long', 
      day: 'numeric' 
    });
  }
};
